import { createContext } from 'react';
import { PaymentDetails } from '@src/@types/payments';

export const PaymentsContext = createContext<PaymentDetails[]>([]);
